<template>
  <div class="message-detail-form">
    <div class="message-detail-form-content">
      <el-row v-if="showTitle" class="form-item">
        <el-col :span="2" class="label">标题</el-col>
        <el-col :span="22">{{ data.title }}</el-col>
      </el-row>
      <el-row class="form-item">
        <el-col :span="2" class="label">正文</el-col>
        <el-col :span="22">
          <div
            class="w-editor-content-style"
            style="background: #fafafb; padding: 15px; box-sizing: border-box; border-radius: 4px"
            v-html="data && data.content"
          ></div>
        </el-col>
      </el-row>
      <el-row class="form-item">
        <el-col :span="2" class="label">附件</el-col>
        <el-col :span="22">
          <div v-for="(file, index) in data.file || []" :key="index" class="file">
            <a :href="file.url" target="_blank" download>
              <i class="el-icon-paperclip" style="margin-right: 5px"></i>
              {{ file.name }}
            </a>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="footer">
      <el-row class="ui-align-center margin-b-10" v-if="indexData">
        {{ indexData.index + ' / ' + indexData.total }}
      </el-row>
      <el-row class="ui-align-center" v-if="[1, 2].includes(data.appMsgStatus)">
        <el-button class="know-button" @click="onKonw" :disabled="readFlag">
          我已知晓
        </el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import { pushLXModuleClick } from '../../utils'

export default {
  name: 'MessageDetail',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    indexData: {
      type: Object,
      default: null,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      readFlag: false,
      cid: 'c_mobikeops_8fa4un26',
    }
  },
  computed: {
    misId() {
      return window.__BIKE_POLARIS__.mis
    },
  },
  methods: {
    /**
     * 消息曝光 / 点击我已知晓
     * @param {Number} type 1 曝光，2 点击已知晓
     */
    receiptMessage(type) {
      const params = {
        msgId: this.data.appMsgId,
        messageTemplateId: this.data.templateId,
        receiptType: type,
      }
      this.fetch.post('receiptMessage', params).then(() => {})
    },

    /** 点击我已知晓 */
    onKonw() {
      this.readFlag = true
      this.receiptMessage(2)

      // 我已知晓埋点
      pushLXModuleClick('b_mobikeops_rdgft1cd_mc', this.cid, this.misId, {
        title: this.data.title,
        topic_id: this.data.templateId,
      })

      // 自动切换下一条消息
      this.$emit('next')
    },

    /**
     * 曝光埋点 + 曝光
     */
    receipt() {
      if (this.data.appMsgStatus === 1) {
        // 未曝光
        this.receiptMessage(1)
        this.setMsgLxAnalytics()
      }
    },

    // 消息曝光埋点
    setMsgLxAnalytics() {
      window.LXAnalytics &&
        window.LXAnalytics(
          'pageView',
          {
            custom: {
              daxiang_mis_number: this.misId,
              title: this.data.title,
              topic_id: this.data.templateId,
            },
          },
          null,
          this.cid
        )
    },
  },
}
</script>

<style lang="scss" scoped>
.message-detail-form {
  position: relative;
  min-height: 500px;
  .message-detail-form-content {
    height: 100%;
    padding-bottom: 80px;
    box-sizing: border-box;
  }
  .form-item {
    margin-bottom: 20px;
    .label {
      font-weight: 500;
    }
    .file {
      margin-bottom: 10px;
      a {
        color: #409eff;
        font-size: 13px;
        &:hover {
          color: #035bb3;
        }
      }
    }
  }
  .footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 10px;
    text-align: center;
    .know-button {
      color: #fff;
      background: #156af0;
      border-color: #156af0;
    }
  }
}
</style>
